import { AxiosError } from 'axios';
import {
  APPLY_INCOMING_CONNECTIONS_REQUEST,
  APPLY_INCOMING_CONNECTIONS_SUCCESS,
  FETCH_ACTIVE_CONNECTIONS_FAILURE,
  FETCH_ACTIVE_CONNECTIONS_REQUEST,
  FETCH_ACTIVE_CONNECTIONS_SUCCESS,
  FETCH_ALL_PENDING_CONNECTIONS_FAILURE,
  FETCH_ALL_PENDING_CONNECTIONS_REQUEST,
  FETCH_ALL_PENDING_CONNECTIONS_SUCCESS
} from '../constants/connections';
import { Actions } from '../actions/connections';
import { IPendingConnection } from '../interfaces';

export type State = {
  allPendingConnections: IPendingConnection[];
  activeConnectionsCount: number;
  error: AxiosError | null;
  isFetching: boolean;
};

const initialState: State = {
  allPendingConnections: [],
  activeConnectionsCount: 0,
  error: null,
  isFetching: false
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case FETCH_ALL_PENDING_CONNECTIONS_REQUEST:
    case FETCH_ACTIVE_CONNECTIONS_REQUEST:
    case APPLY_INCOMING_CONNECTIONS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_ALL_PENDING_CONNECTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        allPendingConnections: action.payload
      };
    case FETCH_ACTIVE_CONNECTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        activeConnectionsCount: action.payload
      };
    case APPLY_INCOMING_CONNECTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false
      };
    case FETCH_ALL_PENDING_CONNECTIONS_FAILURE:
    case FETCH_ACTIVE_CONNECTIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
